{
  "version": 1,
  "asset_id": "97ca58fa-01d7-407a-990c-081d6f7b33a6",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/97ca58fa-01d7-407a-990c-081d6f7b33a6/str-full-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/97ca58fa-01d7-407a-990c-081d6f7b33a6/str-full-placeholder.jpg",
  "original_filename": "str-full-placeholder.jpg",
  "size": 1276467,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T15:28:14Z"
}
